<template>
  <div>
    <v-text-field
      v-bind="{ ...$attrs }"
      :value="value"
      @input="emit"
      :readonly="readonly"
    >
      <template
        v-for="(_, scopedSlotName) in $slots"
        #[scopedSlotName]="slotData"
      >
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>
      <template v-for="(_, slotName) in $slots" #[slotName]>
        <slot :name="slotName" />
      </template>
    </v-text-field>
  </div>
</template>

<script>
import store from "../../store/store";
export default {
  name: "vonex-text",
  inheritAttrs: true,
  props: ["value", "options"],
  computed: {
    fieldValue: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit("input", e);
      },
    },
    rules() {
      let manualRule = this.$attrs.rule;
      let customRule =
        this.options &&
        this.options
          .filter((x) => x.ref == this.$attrs.name)
          .map((y) => y.rule)[0];

      if (store.getters["orders/isQuote"]) {
        return customRule ? customRule : "";
      } else {
        return manualRule ? manualRule : customRule;
      }
    },
    hidden() {
      let manualHidden = this.$attrs.hidden;
      let customHidden =
        this.options &&
        this.options
          .filter((x) => x.ref == this.$attrs.name)
          .map((y) => y.option) == "hidden";

      return manualHidden ? manualHidden : customHidden;
    },
    readonly() {
      let manualReadonly = this.$attrs.readonly;
      let customReadonly =
        this.options &&
        this.options
          .filter((x) => x.ref == this.$attrs.name)
          .map((y) => y.option) == "disabled";

      return manualReadonly ? manualReadonly : customReadonly;
    },
  },
  methods: {
    emit(val) {
      this.$emit("input", val);
    },
  },
};
</script>
